import { render } from "./hamburgerIcon.vue?vue&type=template&id=0731a842"
import script from "./hamburgerIcon.vue?vue&type=script&lang=js"
export * from "./hamburgerIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__